const { h, render, Component } = require('preact');

class TotalAmount extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <table class="remaining-tables">
        <tr>
          <td>
            <span class="order-total">{I18n.translate("js.modules.web_2018.order_total")}:</span>
            <br/>
            {(this.props.orderDetails.purchaseHistory.firstPayment.name) &&
              <span>({this.props.orderDetails.purchaseHistory.firstPayment.name})</span>
            }
          </td>
          <td><span class="order-total">{this.props.orderDetails.purchaseHistory.formattedTotalPrice}</span></td>
        </tr>
      </table>
    );
  }
}
module.exports = TotalAmount
